import { useRef, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import AuthContext from '../../store/auth-context';
import {getBackendURL} from '../../common/Backend';
import classes from './ProfileForm.module.css';


const ProfileForm = () => {
  const backendUrl = getBackendURL();
  const history = useNavigate();

  const newPasswordInputRef = useRef();
  const oldPasswordInputRef = useRef();

  const [email, setEmail] = useState(undefined);
  const [status, setStatus] = useState("");

  const authCtx = useContext(AuthContext);

  useEffect(() => {
    const fetchMe = async () => {
    const response = await fetch(backendUrl+'/users/me', {
    method: 'GET',
    headers: {
    'Content-Type': 'application/json',
    "Authorization": "Bearer " + authCtx.token
    }});

    if(response.ok)
    {
      const responseData = await response.json();
      setEmail(responseData.email);
    }
  }
  fetchMe();

  }, [authCtx.token, email, backendUrl])

  const submitHandler = (event) => {
    event.preventDefault();

    const enteredNewPassword = newPasswordInputRef.current.value;
    const enteredOldPassword = oldPasswordInputRef.current.value;

    // verify old password
    var details = {
      'username': email,
      'password': enteredOldPassword,
      'grant_type': 'password'
    };
  
    var formBody = [];
    for (var property in details) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(details[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");
    var body = formBody

    fetch(backendUrl+'/auth/jwt/login', {
      method: 'POST',
      body: body,
      headers : {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
    }).then( (response) => {

      console.log(response)

      if(response.ok) {

        fetch(backendUrl + '/users/me', {
          method: 'PATCH',
          body: JSON.stringify({
            idToken: authCtx.token,
            password: enteredNewPassword,
          }),
          headers: {
            'Content-Type': 'application/json',
            "Authorization": "Bearer " + authCtx.token
          }
        }).then((patchResponse) => {

          console.log(patchResponse)
          if(patchResponse.ok) {
            history.replace('/');
          
          } else {
            console(patchResponse)
            setStatus("Change password failed")
          }
        });

      } else {
        console.log(response)
        setStatus("Invalid password")

      }
    })
  };

  return (
    <form className={classes.form} onSubmit={submitHandler}>
      <div className={classes.control}>
        <label htmlFor='old-password'>Old Password</label>
        <input type='password' id='old-password' minLength="3" ref={oldPasswordInputRef} />
      </div>
      <div className={classes.control}>
        <label htmlFor='new-password'>New Password</label>
        <input type='password' id='new-password' minLength="3" ref={newPasswordInputRef} />
      </div>
      <div className={classes.action}>
        <button>Change Password</button>
      </div>

      <div className={classes.action}>
        {status}
      </div>
    </form>
  );
};

export default ProfileForm;
